// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: var(--planeed-color-white);
  --padding-bottom: 0 !important;
}

ion-toolbar {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.flex-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.sheet-modal {
  position: relative;
  display: flex;
  flex-direction: column;
}

.sheet-modal-content {
  flex: 1;
}

.sheet-modal-image {
  height: 190px;
}
.sheet-modal-image ion-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.sheet-modal-button {
  display: flex;
  justify-content: end;
  margin-right: 12px;
  margin-left: 12px;
  margin-top: 12px;
}

.sheet-modal-inner-content {
  padding: 12px 12px 0;
}

.action-point-box {
  border: 2px solid var(--ion-color-medium);
  width: 80px;
  height: 80px;
  text-align: center;
  font-size: 25px;
  position: relative;
  border-radius: 50%;
  margin: 0 auto;
  margin-top: 20px;
}

.impact-score-box {
  border: 2px solid var(--ion-color-warning);
  width: 100px;
  height: 100px;
  text-align: center;
  font-size: 25px;
  position: relative;
  border-radius: 50%;
  margin-top: -20px;
  margin: 0 auto;
}

.member-box {
  border: 2px solid var(--ion-color-medium);
  width: 80px;
  height: 80px;
  text-align: center;
  font-size: 25px;
  position: relative;
  border-radius: 50%;
  margin-left: 13px;
  margin: 0 auto;
  margin-top: 20px;
}

.action-point-box ion-icon {
  background: var(--planeed-color-white);
  margin-top: -10px;
  position: absolute;
  margin-left: -15px;
  width: 32px;
}

.member-box ion-icon {
  background: var(--planeed-color-white);
  margin-top: -10px;
  position: absolute;
  margin-left: -15px;
  width: 32px;
}

.impact-score-box ion-icon {
  background: var(--planeed-color-white);
  margin-top: -10px;
  position: absolute;
  margin-left: -15px;
  width: 32px;
}

.score-heading {
  text-align: center;
  color: var(--ion-color-medium);
  font-size: 12px;
}

.score-content {
  position: relative;
  margin-top: -80px;
  padding-bottom: 21px;
  color: var(--ion-color-medium);
}

.score-content-center {
  font-size: 16px;
  text-align: center;
  position: relative;
  margin-top: 20px;
}

.score-content-center2 {
  font-size: 15px;
  color: var(--ion-color-warning);
  text-align: center;
}

.score-text {
  margin-top: 15px;
}

hr {
  padding: 0;
  width: 50%;
  margin: 0 auto;
  background: var(--ion-color-warning);
}

.impact_score_txt {
  color: var(--ion-color-warning);
}

.stat-content {
  margin: 12px 0;
}

.segment-content {
  padding: 0 12px 60px;
}

ion-segment-button {
  --background: transparent;
  --color: inherit;
  --background-checked: var(--ion-color-secondary);
  --color-checked: var(--planeed-color-white);
  --border-radius: 20px;
  --padding-start: 15px;
  --padding-end: 15px;
  --indicator-color: transparent;
  --indicator-box-shadow: none;
  --border-width: 0;
}

.panel-content-header {
  position: relative;
  width: 100%;
}

.side-panel-image {
  height: 150px;
  width: 100%;
  object-fit: cover;
  object-position: center;
}

.side-panel-button {
  display: flex;
  justify-content: end;
  margin: 20px 20px 0 0;
}

.profile-header-img {
  width: 100%;
  object-fit: cover;
  object-position: center;
}

.panel-content {
  display: flex;
  flex-direction: column;
  padding: 20px 20px 0 20px;
}

.panel-content-text {
  padding-bottom: 20px;
}

.side-panel-headline {
  display: flex;
  align-items: center;
  justify-content: center;
}

.panel-content-headline {
  color: var(--planeed-black);
  font-size: 20px;
  line-height: 26px;
  font-weight: 500;
}

.panel-content-subline {
  padding-top: 5px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: var(--planeed-gray);
}

.panel-content-subline-bold {
  margin-left: 5px;
  font-weight: bold;
  color: var(--planeed-blue);
  font-size: 16px;
  line-height: 24px;
}

.panel-content-description {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: var(--planeed-gray);
}

.panel-content-moment {
  height: 100%;
  width: 100%;
}

.panel-content-header-action {
  position: relative;
  width: 100%;
  height: 100%;
}

.side-panel-image-action {
  height: 33%;
  width: 100%;
  object-fit: cover;
  object-position: center;
}

.point-of-action-data {
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.point-of-action-location {
  display: flex;
  align-items: center;
}

.point-of-action-location-text {
  color: var(--planeed-gray);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.point-of-action-creator {
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
}

.point-of-action-icon {
  font-size: 20px;
  margin-right: 5px;
  margin-bottom: 5px;
}

.point-of-action-creator-image {
  height: 30px;
  width: 30px;
  object-fit: cover;
  overflow: hidden;
  border-radius: 5px;
  margin: auto 0;
}

.text-content-introduction {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: auto 5px auto 0;
}

.action-point-creator-text {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: auto 0 auto 10px;
}

.side-panel-action-point-list {
  display: flex;
  flex-direction: column;
}

.action-point-element {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px;
}

.action-point-element-data {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-left: 10px;
  padding-right: 10px;
  max-width: 60%;
}

.action-point-image {
  width: 75px;
  height: 75px;
  object-fit: cover;
  overflow: hidden;
  border-radius: 6px;
}

.action-point-element-data-headline {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.action-point-element-data-author {
  display: flex;
  align-items: center;
}

.action-point-element-data-author-bold {
  font-weight: 500;
  color: var(--planeed-blue);
  margin-left: 5px;
}

.action-point-element-circle {
  margin-left: auto;
  border: 2px solid var(--planeed-orange);
  border-radius: 50px;
  width: 57px;
  height: 57px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
}
.action-point-element-circle ion-icon {
  padding-top: 3px;
}

.circle-stat-count {
  color: var(--planeed-orange);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.count-group-container {
  display: flex;
  align-items: center;
  gap: 15px;
}

.count-container {
  display: flex;
  align-items: center;
  gap: 5px;
}

.action-point-element-timestamp {
  color: var(--planeed-dark-gray);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
